module.exports = __webpack_public_path__ + "static/img/know_how_5.6370d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/know_how_5.png
// module id = HenB
// module chunks = 0